import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';

const ItemApprovedSummary = ({ partner }) => (
    <StatusSummaryButton
        href="/varen-er-godkjent"
        statusSummary="Handelen er ferdig."
    >
        {partner.name} har fått pengene
    </StatusSummaryButton>
);

ItemApprovedSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default ItemApprovedSummary;



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/summaries/itemApprovedSummary.jsx